// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Table,
  Well,
  Alert
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  getCartDetail,
  updateCart,
  removeItem,
  selectAttributes
} from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";
import bannerImg from "../../../img/2006380_YyczUn.png";
import noImg from "../../../img/no_img.jpg";
import dealImg from "../../../img/Deal-Photo.jpg";
import "react-responsive-tabs/styles.css";

import ReactHtmlParser from "react-html-parser";

import { geolocated } from "react-geolocated";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";

import { Notification } from "../../../components/notifications";

import moment from "moment";

import Cookies from "universal-cookie";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

const cookies = new Cookies();

let rand = require("random-key");

const history = createHashHistory();
let cart = "",
  isLoading = "false",
  validateData = [],
  attributes = [],
  currentIndex = "",
  locID = [];
class Cart extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      quantity: [],
      cartError: "",
      show: false,
      alertMessage: "",
      hover: false,
      validateData: []
    };
    validateData = [];
    attributes = [];
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAttribute = this.handleAttribute.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  checkDuplicateInObject(inputArray) {
    var seenDuplicate = false,
        testObject = [];
    
    let tmpinputArray =  Object.keys(inputArray).map(function(k) { return inputArray[k] });  
    tmpinputArray.map(function(item, iKey) {
      
      if(testObject.length == 0){
        testObject.push({data: item, qty:1});
        delete tmpinputArray[iKey];
      }
      else
      {
        let awailIn = false;
        testObject.map(function(oitem, oKey) {
          if(_.isEqual(oitem.data , item)){
            awailIn = oKey;
            delete tmpinputArray[iKey];
            return true;
          }
        })
        if(awailIn !== false){
          testObject[awailIn].qty++;
        }
        else
        {
          testObject.push({data: item, qty:1});
        }
        
      }
    });
    return testObject;
  }

  handleSubmit = e => {
    e.preventDefault();
    let checkDuplicateInObject = this.checkDuplicateInObject;
    
    validateData.map(function(item, iKey) {
      if(validateData[iKey]['attributes'] && validateData[iKey]['attributes']['attribute']){
        validateData[iKey].rawAttribute = checkDuplicateInObject(validateData[iKey]['attributes']['attribute'])
      }
    })
    let newAarray = [];

    this.state.cart.map((data, key) => {
      if(validateData[key]){
        newAarray.push(validateData[key]);
      }else{
        newAarray.push({
          dealID: data.dealID,
          dealLocationID: '',
          quantity: data.quantity,
        });
      }
    });
    let constData = {
      details: newAarray,
      userKey: cookies.get("token")
    };
 
    this.props.selectAttributes(constData);
  };

  handleAttribute = e => {
    let dealID = e.target.attributes.getNamedItem("data-dealid").value;
    let name = e.target.attributes.getNamedItem("data-name").value;
    let index = e.target.attributes.getNamedItem("data-index").value;
    let quantity = e.target.attributes.getNamedItem("data-quantity").value;
    let qtyIndex = (e.target.attributes.getNamedItem("data-qtyindex")) ? e.target.attributes.getNamedItem("data-qtyindex").value : null;
    let dealLocationID = "";
    let cart = this.state.cart[index];
    if(cart.useMerchantDefaultTax === 0){
      let dealLocation = this.state.cart[index].dealLocation;

      if(dealLocation && e.target.value !== ''){
        dealLocation.map((tax, pindex) => {
          if(tax.dealLocationID === parseInt(e.target.value)){
            const newAttribute = this.state.cart.map((data, pidx) => {
              if (parseInt(index) !== parseInt(pidx)) return data;
                return { ...data, tax: tax.taxPerc, total: (((((parseInt(data.quantity) * parseFloat(data.offerPrice)) + parseInt(data.shipping)) * parseFloat(tax.taxPerc))) + parseFloat((parseInt(data.quantity) * parseFloat(data.offerPrice)) + parseInt(data.shipping))) };
            });
            this.setState({ cart: newAttribute });
          }
        });
      }else{
        const newAttribute = this.state.cart.map((data, pidx) => {
          if (parseInt(index) !== parseInt(pidx)) return data;
            return { ...data, tax: 0.00, total: (((((parseInt(data.quantity) * parseFloat(data.offerPrice)) + parseInt(data.shipping)))).toFixed(2)) };
        });
        this.setState({ cart: newAttribute });
      }
    }

    let targetVal = e.target.value;
    if (name == "locID") {
      if (!Array.isArray(locID[index])) {
        locID[index] = [];
      }

      locID[index] = targetVal;
    } else {
      if (currentIndex == "") {
        currentIndex = index;
        attributes = [];
      } else {
        if (currentIndex != index) {
          currentIndex = index;
          attributes = [];
        }
      }

      if(qtyIndex){

        let attrName = '"'+name+'"';

        if (!attributes[index]) {
          attributes = {[index]: {attribute:{[qtyIndex] : {[attrName] : targetVal}}}};  
        }

        if (!attributes[index]['attribute'][qtyIndex]) {
          if(Object.entries(attributes[index]['attribute']).length === 0 && attributes[index]['attribute'].constructor === Object){
            attributes[index]['attribute'] = {[qtyIndex] : {[attrName] : targetVal}};  
          }
          else
          {
            attributes[index]['attribute'] = Object.assign({[qtyIndex] : {[attrName] : targetVal}}, attributes[index]['attribute']);
          }
        }
        if (attributes[index]['attribute'][qtyIndex]) {
          if(!attributes[index]['attribute'][qtyIndex][attrName]){
            attributes[index]['attribute'][qtyIndex] = Object.assign({[attrName] : targetVal}, attributes[index]['attribute'][qtyIndex]);
          }
          else
          {
            attributes[index]['attribute'][qtyIndex][attrName] = targetVal;
          }
        }

        attributes["quantity"] = quantity;
      }
    }
    const constData = {
      dealID: dealID,
      dealLocationID: locID[index] ? locID[index] : "",
      quantity: quantity,
    };
    if(attributes[index]){
      constData.attributes = Object.assign({}, attributes[index])
    }
    validateData[index] = constData;
    this.setState({validateData: validateData})
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  setQuantity = (cartID, type, currentValue, indexKey, dealLocation) => {
    let attr = validateData[indexKey];
    let checkAttr = this.state.cart;

    isLoading = "true";
    let quantity;
    if (type === "add") {
      quantity = currentValue + 1;
    } else {
      validateData = [];
      attributes = [];
      this.setState({validateData: validateData});
      quantity = currentValue - 1;
    }

    if (!isEmpty(checkAttr[indexKey].attributes) && dealLocation == true) {
      if (isEmpty(attr)) {
        isLoading = "false";
        this.handleShow();
        this.setState({
          alertMessage: "Please select attribute.",
          msgType: "danger"
        });
      } else {
        if (quantity >= 1) {
          this.props.updateCart({
            cartID: cartID,
            quantity: 1,
            quantityType: type,
            attributes: attr.attributes
          });
        } else {
          isLoading = "false";
          this.handleShow();
          this.setState({
            alertMessage:
              "At lease one quantity is required for each deal/offer.",
            msgType: "danger"
          });
        }
      }
    } else {
      if (quantity >= 1) {
        this.props.updateCart({
          cartID: cartID,
          quantity: 1,
          quantityType: type
        });
      } else {
        isLoading = "false";
        this.handleShow();
        this.setState({
          alertMessage:
            "At lease one quantity is required for each deal/offer.",
          msgType: "danger"
        });
      }
    }
  };

  handlePageChange = page => {
    isLoading = "true";
    this.props.getCartDetail({ userKey: cookies.get("token") });
  };

  componentWillMount() {
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    this.props.clearAlert();
    this.handleDismiss();
    this.handlePageChange(1);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    // cart detail
    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail) {
        isLoading = "false";
        this.setState({ cart: nextProps.cartDetail.data.data });
      }
    }

    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail.data.data.length == 0) {
        isLoading = "false";
        cart = "empty";
      }
    }
    // cart status
    if (this.props.cartStatus != nextProps.cartStatus) {
      if (nextProps.cartStatus) {
        isLoading = "false";
        this.props.clearAlert();
        if(nextProps.cartStatus.response === 'error'){
          this.handleShow();
          this.props.renderAlert("danger", nextProps.cartStatus.message);
          this.handlePageChange(1);
          window.scrollTo(0, 0);
        }else{
          this.handlePageChange(1);
        }
      }
    }
    
    if (this.props.cartError !== nextProps.cartError) {
      if (nextProps.cartError) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.cartError);
        isLoading = "false";
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.attribute !== nextProps.attribute) {
      if(nextProps.attribute){
        isLoading = "false";
        this.props.clearAlert();
        if(nextProps.attribute.response == 'error'){
          this.handleShow();
          this.props.renderAlert("danger", nextProps.attribute.message);
          window.scrollTo(0, 0);
        }else{
          history.push(`/checkout`);
        }
        
      } 
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.cartDetail != nextState.cartDetail) {
      if (nextState.cartDetail) {
        this.setState({ cart: nextState.cartDetail });
      }
    }
  }

  removeItem = (e, index) => {
    isLoading = "true";
    validateData.splice(index, 1);
    let removeItem = this.state.cart;
    removeItem.splice(index, 1);
    this.setState({ cart: removeItem });
    if (removeItem.length === 0) {
      cart = "empty";
    }
    this.props.removeItem(e);
  };

  render() {
    let validateData = this.state.validateData;
    const { index, direction } = this.state;
    let cartItem,
      i = 1,
      total = 0,
      subRetailPrice = 0,
      subOfferPrice = 0,
      subTotalShipping = 0,
      taxPerc = 0,
      subTotalQty = 0;

    if (!isEmpty(this.state.cart)) {
      cartItem = this.state.cart.map((cart, index) => {
        total = parseFloat(total) + parseFloat(cart.total);
        subTotalQty = parseFloat(subTotalQty) + parseFloat(cart.quantity);
        subRetailPrice = parseFloat(subRetailPrice) + parseFloat(cart.retailPrice);
        subOfferPrice = parseFloat(subOfferPrice) + parseFloat(cart.offerPrice);
        taxPerc = parseFloat(taxPerc) + parseFloat(cart.tax);
        subTotalShipping = parseFloat(subTotalShipping) + parseFloat(cart.shipping);
      });
    }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {isEmpty(this.state.cart) && cart == "empty" ? (
          <div className="container margin-top text-center">
            <Well bsSize="large">
              <h1>Your cart is empty. Please add some offers.</h1>
            </Well>
            <Button
              bsStyle="success"
              style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Continue Shoping') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
              data-id = {'Continue Shoping'}
              onMouseEnter={this.hoverOn} 
              onMouseLeave={this.hoverOff}
              type="submit"
              onClick={() => history.push(`/`)}
            >
              Continue Shopping
            </Button>
          </div>
        ) : (
          <div className="container">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>Message:</strong> {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <form onSubmit={this.handleSubmit} >
              <Table striped bordered condensed hover className="cartgrid">
                <thead style={{ backgroundColor: '#f3f4f5'}}>
                  <tr>
                    <th>#</th>
                    <th>Offer</th>
                    <th>Qty</th>
                    <th>Retail Price</th>
                    <th>Offer Price</th>
                    <th>Shipping</th>
                    <th>Tax</th>
                    <th>Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(this.state.cart)
                    ? (cartItem = this.state.cart.map((cart, indexKey) => (
                        <tr key={Math.random()}>
                          <td className="none">{i++}</td>
                          <td className="offer">
                            {cart.mainDealText}
                            <br />
                            <div>
                              {!isEmpty(cart.dealLocation) && (
                                <Row
                                  className="margin-top"
                                  key={Math.random()}
                                >
                                  <Col md={12} xs={12} key={Math.random()}>
                                    <FormGroup key={Math.random()}>
                                      <Col sm={6}>Location</Col>
                                      <Col sm={6}>
                                        <FormControl
                                          componentClass="select"
                                          defaultValue={
                                            validateData[indexKey]
                                              ? validateData[indexKey]
                                                  .dealLocationID
                                              : ""
                                          }
                                          placeholder="select"
                                          data-quantity={cart.quantity}
                                          data-index={indexKey}
                                          data-id={indexKey}
                                          data-dealid={cart.dealID}
                                          data-name="locID"
                                          onChange={this.handleAttribute}
                                          required
                                        >
                                          <option value="">Select</option>
                                          {!isEmpty(cart.dealLocation) &&
                                            cart.dealLocation.map(
                                              (value, index) => (
                                                <option
                                                  key={index}
                                                  value={value.dealLocationID}
                                                >
                                                  {value.locCity +
                                                    ", " +
                                                    value.locState +
                                                    ", " +
                                                    value.locCountry}
                                                </option>
                                              )
                                            )}
                                        </FormControl>
                                      </Col>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              )}
                              {!isEmpty(cart.attributes) &&
                                _.range(cart.quantity).map((gtyVal, qtyIndex) => {
                                 return cart.attributes.map((attrData, index) => {
                                  let name = '"'+attrData.name+'"';
                                  let valids = [];
                                  let valid = this.state.validateData;
                                  valid = (valid[indexKey] && valid[indexKey]["attributes"]) ? valid[indexKey]["attributes"] : '';
                                  valid = (valid && valid.attribute) ? valid.attribute[qtyIndex] : '';
                                  if(valid){
                                  Object.keys(valid).map(i => valids[i] = valid[i]);
                                  }
                                  return <Row
                                    className="margin-top"
                                    key={Math.random()}
                                  > 
                                    <Col md={12} xs={12} key={Math.random()}>
                                      <FormGroup key={Math.random()}>
                                        <Col sm={6}>Item {qtyIndex + 1} Attribute : {attrData.name} </Col>
                                        <Col sm={6}>
                                          <FormControl
                                            componentClass="select"
                                            defaultValue={
                                              valids ? valids[name] : ""
                                            }
                                            placeholder="select"
                                            data-quantity={cart.quantity}
                                            data-qtyindex={qtyIndex}
                                            data-index={indexKey}
                                            data-id={cart.dealID}
                                            data-dealid={cart.dealID}
                                            data-name={attrData.name}
                                            onChange={this.handleAttribute}
                                            required
                                          >
                                            <option value="">Select</option>
                                            {!isEmpty(attrData.dataValue) &&
                                              attrData.dataValue.map(
                                                (value, index) => (
                                                  <option
                                                    key={index}
                                                    value={
                                                      attrData.type == "menu"
                                                        ? value
                                                        : moment(
                                                            value.startDateTime
                                                          ).format(
                                                            "YYYY-MM-DDTHH:mm"
                                                          ) +
                                                          "-" +
                                                          moment(
                                                            value.endDateTime
                                                          ).format(
                                                            "YYYY-MM-DDTHH:mm"
                                                          )
                                                    }
                                                  >
                                                    {attrData.type == "menu"
                                                      ? value
                                                      : moment(
                                                          value.startDateTime
                                                        ).format(
                                                          "YYYY-MM-DDTHH:mm"
                                                        ) +
                                                        "-" +
                                                        moment(
                                                          value.endDateTime
                                                        ).format(
                                                          "YYYY-MM-DDTHH:mm"
                                                        )}
                                                  </option>
                                                )
                                              )}
                                          </FormControl>
                                        </Col>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                })})}
                            </div>
                            <hr />
                            {ReactHtmlParser(cart.termsAndConditions)}
                          </td>
                          <td className="qty">
                            <FormGroup>
                              <InputGroup>
                                <InputGroup.Button>
                                  <Button
                                    bsStyle="danger"
                                    style={{backgroundColor: (this.state.hover && this.state.hoverID == "minus-"+cart.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                    data-id = {"minus-"+cart.dealID}
                                    onMouseEnter={this.hoverOn} 
                                    onMouseLeave={this.hoverOff}
                                    onClick={this.setQuantity.bind(
                                      this,
                                      cart.cartID,
                                      "sub",
                                      cart.quantity,
                                      indexKey,
                                      !isEmpty(cart.dealLocation) ? true : false,
                                    )}
                                  >
                                    <i className="fa fa-minus" />
                                  </Button>
                                </InputGroup.Button>
                                <FormControl
                                  type="number"
                                  value={cart.quantity}
                                  placeholder="Qty"
                                  name="quantity"
                                  readOnly
                                  className="qty"
                                />
                                <InputGroup.Button>
                                  <Button
                                    style={{backgroundColor: (this.state.hover && this.state.hoverID == "plus-"+cart.dealID) ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                                    data-id = {"plus-"+cart.dealID}
                                    onMouseEnter={this.hoverOn} 
                                    onMouseLeave={this.hoverOff}
                                    bsStyle="success"
                                    onClick={this.setQuantity.bind(
                                      this,
                                      cart.cartID,
                                      "add",
                                      cart.quantity,
                                      indexKey,
                                      !isEmpty(cart.dealLocation) ? true : false,
                                    )}
                                  >
                                    <i className="fa fa-plus" />
                                  </Button>
                                </InputGroup.Button>
                              </InputGroup>
                            </FormGroup>
                          </td>
                          <td className="rprice">${cart.retailPrice}</td>
                          <td className="oprice">${cart.offerPrice}</td>
                          <td className="shipping">${cart.shipping}</td>
                          <td className="tax">{cart.tax}%</td>
                          <td className="total">${cart.total}</td>
                          <td>
                            <Button
                              style={{backgroundColor: (this.state.hover && this.state.hoverID == "trash-"+cart.dealID) ? this.state.mouseover_color : this.state.button_color}}
                              data-id = {"trash-"+cart.dealID}
                              onMouseEnter={this.hoverOn} 
                              onMouseLeave={this.hoverOff}
                              bsStyle="danger"
                              onClick={this.removeItem.bind(
                                this,
                                cart.cartID,
                                indexKey
                              )}
                            >
                              <i className="fa fa-trash" />
                            </Button>
                          </td>
                        </tr>
                      )))
                    : null}
                  {(!isEmpty(this.state.cart) && this.state.cart.length > 1) &&
                    <tr  style={{ backgroundColor: '#f3f4f5'}}>
                      <td className="none"></td>
                      <td className="pull-right none">Sub Total</td>
                      <td className="subqty">{subTotalQty}</td>
                      <td className="subrprice">${subRetailPrice.toFixed(2)}</td>
                      <td className="text-center suboprice">${subOfferPrice.toFixed(2)}</td>
                      <td className="subshipping"><b>${subTotalShipping.toFixed(2)}</b></td>
                      <td className="text-center suboprice">{taxPerc.toFixed(2)}%</td>
                      <td className="total" colSpan="2"><b>${total.toFixed(2)}</b></td>
                    </tr>
                  }
                  <tr  style={{ backgroundColor: '#f3f4f5'}}>
                    <td className="none" colSpan="6" />
                    <td className="text-center none" colSpan="1">
                      Grand Total
                    </td>
                    <td className="text-center gtotal" colSpan="2">
                      <b>${total.toFixed(2)}</b>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Row className="BtnRow">
                <Col md={12} xs={12}>
                  <Button 
                    bsStyle="danger" 
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == "checkout") ? this.state.mouseover_color : this.state.button_color}}
                    data-id = {"checkout"}
                    onMouseEnter={this.hoverOn} 
                    onMouseLeave={this.hoverOff} 
                    type="submit" className="pull-right"
                  >
                    Checkout
                  </Button>
                  <Button
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Shoping') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                    data-id = {'Shoping'}
                    onMouseEnter={this.hoverOn} 
                    onMouseLeave={this.hoverOff}
                    bsStyle="success"
                    className="pull-right"
                    onClick={() => history.push(`/`)}
                  >
                    Continue Shopping
                  </Button>
                </Col>
              </Row>
            </form>
          </div>
        )}
        <hr />
      </div>
    );
  }
}

Cart.propTypes = {
  getCartDetail: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  selectAttributes: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  cartError: state.frontReducer.cartError,
  cartStatus: state.frontReducer.cartStatus,
  cartDetail: state.frontReducer.cartDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  attribute: state.frontReducer.attribute
});

export default compose(
  connect(mapStateToProps, {
    getCartDetail,
    renderAlert,
    clearAlert,
    updateCart,
    removeItem,
    selectAttributes
  })
)(Cart);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Cart.js